import * as React from 'react';

export function IconLoader(): JSX.Element {
    return (
        <svg width="1em"
             height="1em"
             viewBox="0 0 24 30">
            <rect x="0" y="10" width="4" height="10" fill="#00305c" opacity="0.2">
                <animate attributeName="opacity"
                         attributeType="XML"
                         values="0.2; 0.5; 0.2"
                         begin="0s"
                         dur="0.6s"
                         repeatCount="indefinite"/>
                <animate attributeName="height"
                         attributeType="XML"
                         values="10; 20; 10"
                         begin="0s"
                         dur="0.6s"
                         repeatCount="indefinite"/>
                <animate attributeName="y"
                         attributeType="XML"
                         values="10; 5; 10"
                         begin="0s"
                         dur="0.6s"
                         repeatCount="indefinite"/>
            </rect>
            <rect x="8" y="10" width="4" height="10" fill="#00305c" opacity="0.2">
                <animate attributeName="opacity"
                         attributeType="XML"
                         values="0.2; 0.5; 0.2"
                         begin="0.15s"
                         dur="0.6s"
                         repeatCount="indefinite"/>
                <animate attributeName="height"
                         attributeType="XML"
                         values="10; 20; 10"
                         begin="0.15s"
                         dur="0.6s"
                         repeatCount="indefinite"/>
                <animate attributeName="y"
                         attributeType="XML"
                         values="10; 5; 10"
                         begin="0.15s"
                         dur="0.6s"
                         repeatCount="indefinite"/>
            </rect>
            <rect x="16" y="10" width="4" height="10" fill="#00305c" opacity="0.2">
                <animate attributeName="opacity"
                         attributeType="XML"
                         values="0.2; 0.5; 0.2"
                         begin="0.3s"
                         dur="0.6s"
                         repeatCount="indefinite"/>
                <animate attributeName="height"
                         attributeType="XML"
                         values="10; 20; 10"
                         begin="0.3s"
                         dur="0.6s"
                         repeatCount="indefinite"/>
                <animate attributeName="y"
                         attributeType="XML"
                         values="10; 5; 10"
                         begin="0.3s"
                         dur="0.6s"
                         repeatCount="indefinite"/>
            </rect>
        </svg>
    );
}
